import { skipToken, useResource } from 'pulse/react';
import { GetTicketContactsRpc } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc.resources';
import { getIsPreview } from '../utils/isPreview';
import { getPortalAccountId, getPortalInstanceId } from 'portals-platform-lib';
export const useTicketContacts = ticketId => {
  const {
    isPreview
  } = getIsPreview();
  const {
    data,
    loading,
    error
  } = useResource(GetTicketContactsRpc, {
    params: !ticketId || isPreview ? skipToken : {
      accountId: getPortalAccountId(),
      portalInstanceId: getPortalInstanceId(),
      params: {
        ticketId
      }
    }
  });
  return {
    data,
    loading: loading && !data,
    error
  };
};